<template>
  <div>
    <RejectCommentLayout :comment-text="reject_comment" />
        <v-card>
          <v-alert
            color="purple darken-2"
            type="warning"
            icon="mdi-hand-back-left"
            prominent
            text
            class="rounded-bl-0 rounded-br-0"
          >
            <h5>{{ $t('forms.info.affiliationForm.title') }}</h5>
            <div v-html="$t('forms.info.affiliationForm.message')"></div>
            <v-divider
              class="my-4 info"
              style="opacity: 0.22"
            ></v-divider>
            <v-row>
              <v-col
                class="text-center"
                justify="space-around"
              >
                <v-btn
                  color="purple darken-4"
                  outlined
                  :to="`/researchers/${processData.object_id}/forms/vinculationForm`"
                >
                  {{ $t('forms.info.modifyVinculationForm.button') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-alert>
          <v-form class="pa-6" ref="form">
            <v-row>
              <v-col cols="12" md="6">
                <v-combobox
                  v-model="organizationSelected"
                  :items="organizations"
                  item-text="name"
                  :label="$t('label.organization')"
                  return-object
                  outlined
                  :disabled="disabledForm"
                  :rules="rules.fieldRequired"
                ></v-combobox>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-menu
                  v-model="menu_start_date"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                  :disabled="disabledForm"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="investigator.affiliation.start_date"
                      :label="$t('label.startDate')"
                      prepend-inner-icon="event"
                      readonly
                      outlined
                      v-on="on"
                      :rules="rules.fieldRequired"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="investigator.affiliation.start_date"
                    @input="menu_start_date = false"
                    :locale="$store.state.language"
                    :readonly="disabledForm"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="6">
                <v-menu
                  v-model="menu_end_date"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                  :disabled="disabledForm"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="investigator.affiliation.end_date"
                      :label="$t('label.endDate')"
                      prepend-inner-icon="event"
                      readonly
                      outlined
                      v-on="on"
                      :rules="rules.fieldRequired"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="investigator.affiliation.end_date"
                    :min="investigator.affiliation.start_date"
                    @input="menu_end_date = false"
                    :locale="$store.state.language"
                    :readonly="disabledForm"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-divider />
            <UserFormActions
              form_name_text="Affiliation"
              :form_name="form_name"
              :refForm="$refs.form"
              :object_type="object_type"
              :data="processData"
              :state="state"
              @change-state="changeState"
            />
          </v-form>
        </v-card>
  </div>
</template>

<script>
import axios from "axios";
import RejectCommentLayout from "../../layouts/RejectCommentLayout";
import UserFormActions from "../../action_buttons/UserFormActions";
import changeState from "../../../mixins/changeState";
import validationRules from "../../../mixins/validationRules";
import investigatorData from "../../../mixins/investigator_data";
import investigator_model from "../../../mixins/model_utils/investigator_model";

export default {
  mixins: [changeState, validationRules, investigatorData, investigator_model],
  components: { RejectCommentLayout, UserFormActions },

  data: () => ({
    menu_start_date: false,
    menu_end_date: false,
    object_type: "investigator",
    form_name: "affiliationForm",
    state: "",
    reject_comment: "",
    organizationSelected:"",
  }),

  created() {
    this.getOrganizations();
    this.getData();
  },

  computed: {
    updateOrganizationForm() {
      return this.$route.meta.updateForm;
    },
    disabledForm() {
      let states = ["VD", "PA", "PV", "PC"];
      return states.includes(this.state);
    },
    processData() {
      return {
        title: this.investigator.name,
        object_type: this.object_type,
        form_name: this.form_name,
        object_id: this.investigator.id,
        data: {
          user: {
            affiliation: {
              person: this.investigator.id,
              start_date: this.investigator.affiliation.start_date,
              end_date: this.investigator.affiliation.end_date,
              organization: this.organizationSelected.id
            }
          }
        }
      };
    }
  },

  methods: {
    getData() {
      let path = "";
      if (this.updateOrganizationForm || this.$route.meta.readOnly) {
        path =
          this.$store.state.endpoint +
          "/user/moderatedOperations/investigator/" +
          this.$route.params.id;
        axios
          .get(path)
          .then(response => {
            this.investigator.affiliation = response.data.data.user.affiliation;
            this.state = response.data.state;
            this.reject_comment = response.data.reject_comment;
            this.investigator.id = response.data.object_id;
            this.getInvestigatorName(this.$store.state.endpoint + "/person/" + this.investigator.id);
            this.loadOrganizationSelected(this.investigator.affiliation.organization);
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        this.getInvestigatorName(this.$store.state.endpoint + "/person/" + this.$route.params.id);
      }
    },

    loadOrganizationSelected(item) {
        this.organizationSelected = this.organizations.find(
                organization => organization.id === item
        );
    },
  }
};
</script>
